"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportBuilder = void 0;
const CompositeReportBuilder_1 = require("../calculation/CompositeReportBuilder");
const MeasureReportBuilder_1 = __importDefault(require("../calculation/MeasureReportBuilder"));
const MeasureBundleHelpers_1 = require("./MeasureBundleHelpers");
function getReportBuilder(measureBundle, options) {
    const compositeMeasureResource = (0, MeasureBundleHelpers_1.extractCompositeMeasure)(measureBundle);
    if (compositeMeasureResource) {
        return new CompositeReportBuilder_1.CompositeReportBuilder(compositeMeasureResource, options);
    }
    const regularMeasureResource = (0, MeasureBundleHelpers_1.extractMeasureFromBundle)(measureBundle);
    return new MeasureReportBuilder_1.default(regularMeasureResource, options);
}
exports.getReportBuilder = getReportBuilder;
//# sourceMappingURL=ReportBuilderFactory.js.map